// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledPdfNotif = styled('div')(
  () => css`
    .pdf-notif {
      &.disabled {
        opacity: 0.5;
      }

      .bullet {
        width: 12px;
        height: 12px;
        background: #4c6fff;
        border: 2px solid #ffffff;
        box-sizing: border-box;
        border-radius: 11px;
      }

      .file-is-ready {
        color: #777777;
        font-size: 0.75rem;
        text-align: right;
        flex: 1;
      }

      .date-time {
        color: #777777;
        font-size: 0.625rem;
      }

      .icon {
        margin-right: 0 !important;
      }

      .file-name {
        font-weight: bold;
        font-size: 0.875rem;
        line-height: 24px;
        text-align: right;
        color: #454545;
        margin-right: 25px;
      }

      .fullwidth {
        width: calc(100% - 10px);
        margin-right: 10px;
      }
    }
  `
);
